__turbopack_context__.v({
  "simpleButton": "simpleButton-module-scss-module__NsiEJG__simpleButton",
});
